import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { ModalService } from '@collab/comp-library';


@Component({
  selector: 'app-video-container',
  templateUrl: './video-container.component.html',
  styleUrls: ['./video-container.component.scss']
})
export class VideoContainerComponent implements OnInit {

  @Input() public modalConfig!: any;
  @Input() public videoUrl!: string;
  @Input() public posterUrl!: string;
  @Input() public id!: string;
  @Input() public productDetails: any;

  private element: any;

  constructor(private modalService: ModalService, private el: ElementRef) {
      this.element = el.nativeElement;
  }

  public ngOnInit(): void {

        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // close modal on background click
        this.element.addEventListener('click', (e: any) => {
            if (e.target.className === 'modal') {
                const videoElements = document.querySelectorAll('video');

                videoElements.forEach((video) => {
                    if (video.id === this.id) {
                        video.pause();
                        video.removeAttribute('src');
                        video.load();
                        this.modalService.close(this.id);
                    }
                });
            }
        });

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);

  }

    // open modal
    public open(): void {
        this.element.style.display = 'block';
        document.body.classList.add('modal-open');
    }

    // close modal
    public close(): void {
        this.element.style.display = 'none';

        document.body.classList.remove('modal-open');
    }

}
